import React, { useState, useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box
} from "@mui/material";
import basso from '../../assets/rischio_basso.png';
import medio from '../../assets/rischio_medio.png';
import alto from '../../assets/rischio_alto.png';

//PROGETTO
const questions1 = [
  { question: "1. Competenze del team proponente o attuatore", options: ["Team e PM noti ed esperti", "Team e PM noti, ma con poca esperienza; Team e PM non noti, ma con buon track record", "Team e PM non noti e senza track record o, se noti, con criticità gestionali in passato"] },
  { question: "2. Complessità operativa del progetto", options: ["Attività semplici, pochi partner coinvolti, territorio ristretto", "Attività articolate, pochi partner coinvolti, territorio esteso", "Attività articolate, molti partner coinvolti (sia pubblici, sia privati), territorio esteso"] },
  { question: "3. Dipendenza da fattori esterni e durata del progetto", options: ["Ente proponente/attuatore in completo controllo di risorse e attività, progetti di breve durata", "Alcune possibili dipendenze da elementi esterni al progetto", "Forte dipendenza da elementi esterni (ciclo elettorale, economico, normativa) e durata triennale o superiore"] },
  { question: "4. Stabilità delle risorse finanziarie (cofinanziamento interno e risorse di terzi)", options: ["Spese coperte con fondi già ottenuti dall'ente", "Spese coperte perlopiù con fondi già ottenuti dall'ente", "Fondi perlopiù ipotizzati"] },
  { question: "5. Innovazione e grado di sperimentazione", options: ["Contenuti del progetto e modalità operative già testati", "Contenuti del progetto e modalità operative con grado di innovazione limitato", "Progetto fortemente innovativo, sperimentale, senza benchmark"] },  
  { question: "6. Presidio e capacità di monitoraggio del progetto", options: ["È previsto un sistema strutturato di monitoraggio con indicatori e momenti di valutazione nel corso (in itinere) e alla fine del progetto (ex-post)", "È previsto un sistema strutturato di monitoraggio con indicatori e momenti di valutazione alla fine del progetto (ex-post)", "Il progetto non prevede un sistema strutturato di monitoraggio tramite indicatori"] }
];

//BANDO/LINEE GUIDA
const questions2 = [
  { question: "1. Originalità del tema rispetto al contesto filantropico o territoriale", options: ["Tema già noto e riconosciuto nel contesto di riferimento; esistono attori potenzialmente interessati", "Tema parzialmente esplorato; presenza discontinua di attori competenti", "Tema completamente nuovo per il contesto; rischio di disorientamento o incomprensione da parte dei potenziali candidati"] },
  { question: "2. Grado di innovazione richiesto ai candidati (sperimentazione, prototipi, modelli nuovi)", options: ["Il bando stimola miglioramenti incrementali o adattamenti di modelli esistenti", "Il bando incoraggia innovazioni moderate, con riferimenti deboli o di nicchia", "Il bando sollecita sperimentazioni radicali senza riferimenti consolidati; elevata incertezza sull'effettiva traducibilità in proposte operative"] },
  { question: "3. Grado di innovazione per la struttura della FCSP", options: ["Ambiti di intervento e modalità operative già testati nei quadrienni precedenti", "Ambiti di intervento e modalità operative nuovi per la FCSP, ma già testati da enti analoghi in territori affini", "Ambiti di intervento e modalità operative fortemente innovativi, senza benchmark in territori affini"] },
  { question: "4. Ambizione dei traguardi attesi / trasformatività", options: ["Obiettivi compatibili con la capacità media degli attori del territorio.", "Obiettivi ambiziosi che richiedono uno sforzo significativo e coordinato", "Obiettivi altamente trasformativi, probabilmente sproporzionati rispetto alle risorse e al tempo disponibili"] },
  { question: "5. Conoscenza e complessità del target (beneficiari finali)", options: ["Il target è già stato oggetto di progettualità analoghe, con canali di accesso consolidati", "Il target è nuovo per la maggior parte degli attori, ma teoricamente raggiungibile con sforzi mirati", "Il target è storicamente difficile da coinvolgere o da identificare; assenza di esperienze pregresse"] },
  { question: "6. Esistenza di attori maturi e pronti a rispondere al bando", options: ["La comunità professionale o civile è strutturata e abituata a rispondere a bandi analoghi", "Alcuni attori potenzialmente interessati sono presenti ma poco attivi o poco capaci", "È incerto che esistano soggetti in grado di candidarsi in modo coerente; rischio di scarsa qualità delle candidature"] },
  { question: "7. Dipendenza del successo del bando da fattori esterni ", options: ["Il successo dipende principalmente dai progetti candidati, con poche variabili esterne", "Sono previsti alcuni elementi esterni rilevanti (es. partenariati istituzionali, adesione di stakeholder)", "Il successo del bando richiede il verificarsi di condizioni esterne non governabili (es. policy pubbliche, cambiamenti culturali, accesso a dati o reti)"] },
  { question: "8. Rischio di disallineamento tra ambizione e strumenti disponibili", options: ["Il bando fornisce risorse, tempi, accompagnamento e regole coerenti con gli obiettivi attesi", "Alcuni strumenti di supporto sono presenti, ma potrebbero non essere sufficienti per tutti i candidati", "L’articolazione del bando (budget, tempi, struttura) presenta elementi che richiedono notevole tempestività ed efficienza dei soggetti candidati"] }
];

const weights = [1, 2, 5];



export default function RiskDialog({ open, onClose }) {
  const [path, setPath] = useState(null);         
  const [step, setStep] = useState(0);            
  const [answers, setAnswers] = useState({});     
  const [showResult, setShowResult] = useState(false);
  const [showingSelection, setShowingSelection] = useState(false);

  const questions = useMemo(() => {
    if (path === "1") return questions1;
    if (path === "2") return questions2;
    return [];
  }, [path]);

  const questionsCount = questions.length;

  const handlePathChange = (e) => {
    const v = e.target.value;
    setPath(v);
    setAnswers({ 0: v });
    setShowResult(false);
    setStep(1); // vai subito alla prima domanda
  };

  /*
  const handleAnswerChange = (value) => {
    setAnswers((prev) => ({ ...prev, [step]: value }));
  };
  */
  
  /*const handleAnswerChange = (value) => {
    setAnswers((prev) => ({ ...prev, [step]: value }));
  
    // se non siamo all'ultima domanda, avanza
    if (step < questionsCount) {
      setStep(step + 1);
    } else {
      // se è l'ultima domanda mostra direttamente il risultato
      setShowResult(true);
    }
  };
  */

  const handleAnswerChange = (value) => {    
    setAnswers((prev) => ({ ...prev, [step]: value }));      
    setShowingSelection(true);  
    setTimeout(() => {
      setShowingSelection(false);
      if (step < questionsCount) {
        setStep(step + 1);
      } else {
        setShowResult(true);
      }
    }, 150); 
  };

  const handleNext = () => {
    if (step === 0) {
      if (!path) return;
      setStep(1);
      return;
    }
    if (step < questionsCount) {
      setStep(step + 1);
      return;
    }
    if (step === questionsCount) {
      setShowResult(true);
    }
  };

  const handleBack = () => {
    if (showResult) {
      setShowResult(false);
      setStep(questionsCount);
      return;
    }
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const canProceed = () => {
    if (showResult) return true;
    if (step === 0) return !!path;
    return !!answers[step];
  };

  const calculateScore = () => {
    let total = 0;
    for (let i = 1; i <= questionsCount; i++) {
      const val = answers[i];
      if (!val) continue;
      const q = questions[i - 1];
      const idx = q.options.indexOf(val);
      if (idx >= 0) total += weights[idx];
    }
    return total;
  };

  const calculateRisk = () => {
    let total = 0;
    for (let i = 1; i <= questionsCount; i++) {
      const val = answers[i];
      if (!val) continue;
      const q = questions[i - 1];
      const idx = q.options.indexOf(val);
      if (idx >= 0) total += weights[idx];
    }
    console.log("Q?", questionsCount);
    if(questionsCount==7) { //PROGETTO
        if (total >=18)
            return "ALTO";
        else if(total > 10)
            return "MEDIO";            
        else    
            return "BASSO";    
    }
    else{ //BANDO
        if (total >=20)
            return "ALTO";
        else if(total > 12)
            return "MEDIO";            
        else    
            return "BASSO";    
    }        
  };

  const calculateColor = () => {
    let total = 0;
    for (let i = 1; i <= questionsCount; i++) {
      const val = answers[i];
      if (!val) continue;
      const q = questions[i - 1];
      const idx = q.options.indexOf(val);
      if (idx >= 0) total += weights[idx];
    }
    console.log("Q?", questionsCount);
    if(questionsCount==7) { //PROGETTO
        if (total >=18)
            return "red";
        else if(total > 10)
            return "orange";            
        else    
            return "green";    
    }
    else{ //BANDO
        if (total >=20)
            return "red";
        else if(total > 12)
            return "orange";            
        else    
            return "green";    
    }        
  };
  

  //const title = `Calcolo del Rischio${path === "1" ? " - Progetto" : path === "2" ? " - Bando/Linee Guida" : ""}`;
  const title =
  step === 0
    ? "Calcolo del Rischio"
    : `Calcolo del Rischio${path === "1" ? " - Progetto" : path === "2" ? " - Bando/Linee Guida" : ""}`;
  const progressText = step > 0 && !showResult ? `${step}/${questionsCount}` : "";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{fontWeight:'bold'}}>{title}</DialogTitle>

      <DialogContent
        dividers
        style={{
          minHeight: 430,          
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        {/* Contenuto principale */}
        <Box flexGrow={1} display="flex" flexDirection="column" justifyContent="center">
          {step === 0 && (
            <Box>
              <Typography variant="subtitle1" gutterBottom>
              Le seguenti domande sono di supporto per la corretta attribuzione del fattore rischio. Cominciamo selezionando la tipologia di pratica e poi, a seconda della scelta, verranno poste una serie di domande specifiche:
              </Typography>
              <RadioGroup value={path || ""} onChange={handlePathChange}>
                <FormControlLabel value="1" control={<Radio />} label="Progetto" />
                <FormControlLabel value="2" control={<Radio />} label="Bando/Linee Guida" />
              </RadioGroup>
            </Box>
          )}

          {path && !showResult && step > 0 && (
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                {questions[step - 1].question}
              </Typography>
              
              {/*<RadioGroup
                value={answers[step] || ""}
                onChange={(e) => handleAnswerChange(e.target.value)}
              >
                {questions[step - 1].options.map((opt, i) => (
                  <FormControlLabel key={i} value={opt} control={<Radio />} label={opt} />
                ))}
              </RadioGroup> */}
              <RadioGroup
  value={answers[step] || ""}
  onChange={(e) => handleAnswerChange(e.target.value)}
>
  {questions[step - 1].options.map((opt, i) => (
    <Box
      key={i}
      mb={1.5}              
      p={1}                 
      borderRadius={1}      
      bgcolor={answers[step] === opt ? "#e3f2fd" : "#f9f9f9"} 
      border="1px solid #ccc" 
    >
      <FormControlLabel
        value={opt}
        control={<Radio />}
        label={opt}
        style={{ width: "100%", margin: 0 }}
      />
    </Box>
  ))}
</RadioGroup>
            </Box>
          )}

          {showResult && (
            <Box>
              <Typography variant="h5" gutterBottom>Risultato finale </Typography>
              <Typography variant="subtitle1" gutterBottom><br></br> </Typography>
              <Typography variant="h5" color={calculateColor}> <b>RISCHIO: {calculateRisk()}</b></Typography>
              
              
              <Box
//      key={i}
      mb={1.5}              
      p={1}                 
      borderRadius={1}      
      bgcolor= "#ffffff"
      border={`1px solid ${calculateColor()}`}
    >
              <Typography>Esprimilo così:</Typography>
              {calculateColor() =="red" ? (
                 <img src={alto} className="logo1" alt="Logo" />)
                 : calculateColor() =="orange"  ?(
                    <img src={medio} className="logo1" alt="Logo" />): (
                        <img src={basso} className="logo1" alt="Logo" />
                    )
            }
    </Box>
              <Typography variant="subtitle1" gutterBottom><br></br> </Typography>
              <Typography>Punteggio totale: {calculateScore()}</Typography>
            </Box>
          )}
        </Box>

        {/* Pallini fissi in basso */}
        {path && !showResult && step > 0 && (
          <Box display="flex" alignItems="center" justifyContent="center" mt={2}>
            {questions.map((_, idx) => {
              const questionStep = idx + 1;
              const isActive = step === questionStep;
              return (
                <Box
                  key={idx}
                  style={{
                    margin: 4,
                    backgroundColor: isActive ? "#1976d2" : "#e0e0e0",
                    width: 14,
                    height: 14,
                    borderRadius: "50%"
                  }}
                />
              );
            })}
            <Typography variant="caption" style={{ marginLeft: 8 }}>
              {progressText}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleBack} disabled={step === 0 && !showResult}>Indietro</Button>
        {!showResult ? (
          <Button onClick={handleNext} color="primary" disabled={!canProceed()}>
            {step === questionsCount ? "Calcola" : "Avanti"}
          </Button>
        ) : (
          <Button onClick={onClose} color="primary">Chiudi</Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

